import React from 'react';
import CompareSlider from './compareSlider';

function BeforeAfter() {
  return (
    <div className="mx-auto">
      <h2 className="font-bold">تصاویر قبل و بعد شاگردان دوره شیپ آپ</h2>
      <div className="grid md:grid-cols-3 xs:grid-rows-2  justify-items-center">
        <CompareSlider
          title="کاهش وزن = ۲۰ کیلو"
          desc="کاهش سایز = دور کم ۱۰ سانتی متر"
          img1={'https://backend.fitlinez.com/uploads/file-1714913137955.jpeg'}
          img2={
            'https://backend.fitlinez.com/Compress_20241112_110637_7818.jpg'
          }
        />
        <CompareSlider
          title="کاهش وزن = ۲۰ کیلو"
          desc="کاهش سایز = دور کم ۱۰ سانتی متر"
          img1={'https://backend.fitlinez.com/uploads/file-1714913137955.jpeg'}
          img2={
            'https://backend.fitlinez.com/Compress_20241112_110637_7818.jpg'
          }
        />
        <CompareSlider
          title="کاهش وزن = ۲۰ کیلو"
          desc="کاهش سایز = دور کم ۱۰ سانتی متر"
          img1={'https://backend.fitlinez.com/uploads/file-1714913137955.jpeg'}
          img2={
            'https://backend.fitlinez.com/Compress_20241112_110637_7818.jpg'
          }
        />
      </div>
    </div>
  );
}

export default BeforeAfter;
